<div class="confirm-modal ig-modal travel-buddy-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div>
        <div class="title">
            <img src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" alt="travel buddy" class="m-r-1"
                width="22px" height="22px" matTooltip="Travel Buddy Settings!">User/Travel Buddy Conversations!
        </div>

        <div style="height:60vh">
            <ig-spinner *ngIf="loadingAccounts"></ig-spinner>
            <ig-drop-down *ngIf="!loadingAccounts" ngClass="event-btn" showDropDownItem="true" style="width:50%"
                class="m-t-2">
                <ig-drop-down-trigger [text]="accountName||'All Accounts'">
                </ig-drop-down-trigger>
                <div items>
                    <ig-drop-down-item *ngFor="let account of accountNames" (click)="setAccount(account)">
                        {{account}}
                    </ig-drop-down-item>
                </div>
            </ig-drop-down>

            <ig-spinner *ngIf="loadingUsers"></ig-spinner>
            <ig-drop-down *ngIf="!loadingUsers && users.length" ngClass="event-btn" showDropDownItem="true"
                style="width:50%" class="m-t-2 m-b-2">
                <ig-drop-down-trigger [text]="userName||'All users'">
                </ig-drop-down-trigger>
                <div items>
                    <ig-drop-down-item *ngFor="let user of users" (click)="setUser(user)">
                        {{processUser(user)}}
                    </ig-drop-down-item>
                </div>
            </ig-drop-down>

            <div style="max-height: 50vh;overflow-y: auto">
                <div *ngFor="let conversation of conversations">
                    <ig-accordion icon="view_list" [title]="getConversationTitle(conversation)">

                        <div class="text-left">
                            <b>User:&nbsp;</b><span>{{conversation.conversation.user}}</span>
                        </div>
                        <div class="text-left">
                            <b>TravelBuddy:&nbsp;</b><span>{{conversation.conversation.ai}}</span>
                        </div>

                    </ig-accordion>
                </div>
            </div>

        </div>

        <div class="action-row flex">
            <ig-button class="m-l-2" color="cancel" (trigger)="close()">
                Cancel
            </ig-button>
            <ig-button size="md" [isAsync]="true" (trigger)="confirm($event)">
                Save
            </ig-button>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/travel.buddy.conversations/travel.buddy.conversations.modal.component.html